import type { FaireProductEntity } from "../../entity_types/product";

export const fine_raw_1: FaireProductEntity = {
  token: "fine-raw-1",
  type: "product",
  name: "Waffle Cone Chunky Chocolate Bar",
  brandName: "Fine & Raw Chocolate",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/901677914a087daf37d3ba0d2491608f5c577da7df9c429056eae062d6ad59a1.webp",
  priceDollars: 8.5,
  msrpDollars: 14,
  freeShipping: false,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
